module.exports = __webpack_public_path__ + "media/application/images/wjc-horizontal-blue-161c762b42b6103c9d7d0d1d99e7f2864ffb7079180262e7a3cd87fe63520065.svg";